import { ComponentModalConfig, ModalSize } from 'ngx-fomantic-ui';
import { required, maxLength, prop } from '@rxweb/reactive-form-validators';

import { FavouriteScreenItem, ScreenListing } from '../../shared';
import {
  FavouriteScreenModalComponent,
  IConfirmModalContext,
} from './favourite-screen-modal/favourite-screen-modal.component';
export class ListingItemModal extends ComponentModalConfig<
  IConfirmModalContext,
  void,
  void
> {
  constructor(title?: string, content?: ScreenListing, size?: any) {
    super(FavouriteScreenModalComponent, { title, content });
    this.isClosable = true;
    this.transitionDuration = 500;
    this.size = ModalSize[size] || ModalSize.Mini;
  }
}

export class FavouriteForm {
  @required({ message: 'Required' })
  @maxLength({ value: 30, message: 'Maximum 30 characters are allowed' })
  favouriteListName: string;

  @prop({ defaultValue: [] })
  screens: FavouriteScreenItem[];
}
